import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RMaterial } from './r-material.action';

interface RMaterialXsStateModel {
  viewAllMaterial: string;
  viewOrganizationMaterial: string;
}

const getDefaults = (): RMaterialXsStateModel => ({
  viewAllMaterial: null,
  viewOrganizationMaterial: null
});

@State<RMaterialXsStateModel>({
  name: 'rMaterial',
  defaults: getDefaults()
})
@Injectable()
export class RMaterialXsState {

  //region SELECTOR

  @Selector()
  static canViewAllMaterial(state: RMaterialXsStateModel): boolean {
    return state.viewAllMaterial != null;
  }

  @Selector()
  static canViewOrganizationMaterial(state: RMaterialXsStateModel): boolean {
    return state.viewOrganizationMaterial != null;
  }

  //endregion

  //region ACTIONS
  @Action(RMaterial.SetMaterialPrivileges)
  public setMaterialPrivileges(ctx: StateContext<RMaterialXsStateModel>, action: RMaterial.SetMaterialPrivileges) {
    const state = ctx.getState();
    const materialPrivileges = [...action.activeUserRightInfoDtoModel.materialPrivileges];

    //find user privilege data model
    const viewAll = materialPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ALL_MATERIALS);
    const viewOrganization = materialPrivileges.find(id => id === UserPrivilegeEnum.VIEW_ORGANIZATION_MATERIALS);

    //set the state
    ctx.setState({
      ...state,
      viewAllMaterial: viewAll,
      viewOrganizationMaterial: viewOrganization
    });
  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RMaterialXsStateModel>): void {
    ctx.setState({ ...getDefaults() });
  }

  //endregion
}
